<!--
功能: 视频录制

属性: 无
SLOT: 无

事件:
sendVideo: 发送成功


案例:
    <VideoRecording ref="videoRecord" v-if="videoRecording" @colseVideoRecordModal="colseVideoRecordModal"/>
-->

<template>
    <div style="display: none">
        <!-- 视频录制 -->
        <Modal v-model="videoRecordModal" :title="getTitle" :closable="false" :mask-closable="false" @on-visible-change="colseVideoRecordModal" class="mooc-charge-video-record-modal">
            <div v-if="!msg">
                <div v-show="isIOS" class="ios-video">
                    <video v-if="videoSrc" id="video" width='320' height="240" :src="videoSrc" controls autoplay></video>
                    <p>按照要求, 请录制 {{ recordVideoTime }} 秒视频, 不得超过 {{ recordVideoTime + 5 }}秒</p>
                </div>
                <div v-show="!isIOS" id="videos-container" style="margin: 10px 0;">
                </div>
                <!-- <p style="font-size: 14px">附：
                    <br>只允许调起摄像头，不允许选择文件
                    <br>活体的视频大小不能超8Mb，时长不能超6秒
                    <br><span id='info'></span>
                </p> -->

                <p>按照人社适岗培训要求，从2021年3月1日开始对学习过程进行防挂机检测。</p>
                <Spin size="large" fix v-if="spinShow"></Spin>
            </div>
            <div v-else>
                <p>{{ msg }}</p>
                <p>按照人社适岗培训要求，必须允许调用摄像头权限方可学习!</p>
                <!-- <div slot="footer">
                </div> -->
            </div>
            <div slot="footer">
                <template v-if="isIOS">
                    <a href="javascript:;" class="a-upload">
                        <input v-if="!spinShow" type="file"  name="video" id="video-input"  accept="video/*" @change="videoChange()" capture="camcorder" >点击录制视频
                    </a>
                </template>
                <template v-else >
                    <Button v-show="!msg" :loading="btnLoading" type="primary" @click="startRecord()">录制</Button>
                </template>
                <!-- <Button  :loading="btnLoading" type="primary" @click="submitVideo()">提交</Button> -->
            </div>
        </Modal>
    </div>
</template>
<script>
import GuangYuanDao from '@/../public/static/js/dao/GuangYuanDao';

export default {
    data() {
        return {
            mediaRecorder: null,
            mediaStream: null,
            recorderFile: null,
            stopRecordCallback: null,
            videosContainer : null,
            recording: false, // 录制中
            videoRecordModal: false, // 录制对话框
            btnLoading: false, // 录制中
            spinShow: false, // 上传中
            isIOS: false, // 是否是ios
            isSafari: false, // 是否是safari
            videoSrc: null, // 视频 src
            msg:'', // 摄像头是否可用
            title:'视频录制',

        };
    },
    created() {
        const sUserAgent = navigator.userAgent.toLowerCase();
        console.log('sUserAgent', sUserAgent);
        this.isIOS = sUserAgent.match(/ipad/i) == 'ipad' || sUserAgent.match(/iphone os/i) == 'iphone os';
        if (sUserAgent.match(/chrome/i) == 'chrome') {
            this.isIOS = false;
        }
        if (sUserAgent.match(/safari/i) == 'safari' && sUserAgent.match(/chrome/i) != 'chrome' && !this.isIOS) {
            this.isSafari = true;
            this.msg = '该课件不支持 safari(苹果) 浏览器播放, 请安装谷歌浏览器学习!';
            this.title = '不支持 safari 浏览器学习';
            this.videoRecordModal = true;
        }
    },
    mounted() {
        var questData = this.$store.state.questData;
        let isModel = Utils.getCookie(questData.resCode + 'v');
        if (isModel && this.recordVideoState != 1) {
            this.recordingVideo(0);
        }
    },
    computed: {
        // 视频录制时长
        recordVideoTime() {
            return this.$store.state.recordConfig.recordVideoTime;
        },
        // 录制方式  1:视频开始后； 2:视频播放1/4时 ；3:视频播放1/3时； 4:视频播放1/2时；
        recordVideoState() {
            return this.$store.state.recordConfig.recordVideoState;
        },
        getTitle() {
            return this.title;
        },

    },
    methods:{
        // getTitle() {
        //     return this.title;
        // },
        videoChange() {
            var file = document.getElementById('video-input').files[0];
            var fileSize = (Math.round(file.size / 1024)).toFixed();
            // document.getElementById('info').innerHTML += '所录视频大小约为：' + (fileSize / 1024).toFixed(2) + 'Mb';
            var url = URL.createObjectURL(file);
            console.log(url);
            this.videoSrc = url;
            this.send(file);
        },
        // 录制调用方法
        recordingVideo(recordTime) {
            // console.log('recordTime', recordTime);
            setTimeout(() => {
                this.start();
            }, recordTime);
        },
        // 开始录制
        start() {
            console.log('this.$store.state.isVideoRecordloading', this.$store.state.isVideoRecordloading);
            // 查询是否视频录制使用中, 如果是则进行延迟 1分钟录制
            if (this.$store.state.isVideoRecordloading) {
                setTimeout(() => {
                    this.start();
                }, 60 * 1000);
            } else {
                // this.isIOS = true;
                if (this.isIOS) {
                    if (!this.videoRecordModal) this.videoRecordModal = true;
                } else {
                    this.openCamera();
                }
            }
        },
        // 当验录制视频弹窗变化时
        colseVideoRecordModal(value) {
            this.$emit('colseVideoRecordModal', value);
            var questData = this.$store.state.questData;
            if (value) {
                this.$store.commit('setIsVideoRecordloading', true);
                if (this.recordVideoState != 1) {
                    Utils.setCookie(questData.resCode + 'v', true, 12, '/page/;');
                }
            } else {
                this.$store.commit('setIsVideoRecordloading', false);
                if (this.recordVideoState != 1) {
                    Utils.setCookie(questData.resCode + 'v', false, 12, '/page/;');
                }
            }
        },
        openCamera() {
            this.videosContainer = document.getElementById('videos-container');
            // console.log('this.videosContainer', this.videosContainer);
            if (this.videosContainer && this.videosContainer.childNodes) {
                var len = this.videosContainer.childNodes.length;
                for (var i=0; i<len; i++) {
                    this.videosContainer.removeChild(this.videosContainer.childNodes[i]);
                }
            }
            var video = document.createElement('video');

            var videoWidth = 320;
            var videoHeight = 240;

            video.controls = false;
            video.muted = false;
            video.width = videoWidth;
            video.height = videoHeight;
            let self = this;
            this.$MediaUtils.getUserMedia(true, false, function (err, stream) {
                if (err) {
                    console.log('err', err);
                    self.getUserMediaError(err);
                } else {
                    // 通过 MediaRecorder 记录获取到的媒体流
                    // console.log('stream', stream);
                    // 设置人脸识别进行中
                    // 设置设备使用中
                    // self.$store.commit('setVideoDevice', true);
                    var options = {
                        audioBitsPerSecond: 128000,
                        videoBitsPerSecond: 2500000,
                        mimeType: 'video/webm;codecs=vp8,opus'//webm类型一定要加codecs=vp8,opus，否则会导致录制时候时而可以用时而不能用
                    };
                    self.mediaRecorder = new MediaRecorder(stream, options);
                    // self.mediaRecorder = new MediaStreamRecorder(stream);
                    self.mediaStream = stream;

                    var chunks = [];
                    var startTime = 0;
                    video.srcObject = stream;
                    video.play();
                    if (!self.videoRecordModal) self.videoRecordModal = true;
                    // // 开始录制
                    // self.startRecord();

                    self.videosContainer.appendChild(video);
                    self.mediaRecorder.ondataavailable = function(e) {
                        console.log('ondataavailable---');
                        self.mediaRecorder.blobs.push(e.data);
                        chunks.push(e.data);
                    };
                    self.mediaRecorder.blobs = [];

                    self.mediaRecorder.onstop = function (e) {
                        self.recorderFile = new Blob(chunks, { 'type' : self.mediaRecorder.mimeType });
                        chunks = [];
                        if (null != self.stopRecordCallback) {
                            self.stopRecordCallback();
                        }
                    };
                }
            });
        },
        startRecord() {
            this.btnLoading = true;
            Utils.info('视频录制中, 请正视摄像头');
            // console.log('开始录制', this.recordVideoTime);
            this.mediaRecorder.start(1000);
            let self = this;
            this.s = setTimeout(function() {
                // 结束
                self.stopRecord(function() {
                    self.spinShow = true;
                    Utils.info('录制完成, 请稍后...');
                    // console.log('录制成功');
                    //send();
                    self.saver();
                });
            }, (self.recordVideoTime + 1) * 1000);
        },
        stopRecord(callback) {
            this.stopRecordCallback = callback;
            // 终止录制器
            this.mediaRecorder.stop();
            // 关闭媒体流
            this.$MediaUtils.closeStream(this.mediaStream);
        },
        saver() {
            var file = new File([this.recorderFile], 'msr-' + (new Date()).toISOString().replace(/:|\./g, '-') + '.mp4', {
                type: 'video/mp4'
            });
            // console.log('保存视频', file);
            // 保存下载视频
            // saveAs(file);
            // 发送视频
            this.send(file);
        },
        // 录制视频提交
        send(file) {
            if (this.isIOS) {
                this.spinShow = true;
                var self = this;
                var audioElement = new Audio(this.videoSrc);
                audioElement.addEventListener('loadedmetadata', function (_event) {
                    const duration = audioElement.duration;
                    const timeMax = self.recordVideoTime + 5;
                    console.log('视频时长：'+duration+'秒');
                    if (duration < self.recordVideoTime) {
                        Utils.warning('视频不足 ' + self.recordVideoTime + '秒,请重新录制');
                        self.spinShow = false;
                    }  else if (duration > timeMax) {
                        Utils.warning('视频超过 ' + timeMax + '秒,请重新录制');
                        self.spinShow = false;
                    } else {
                        self.uploadVideo(file);
                    }
                });
            } else {
                this.uploadVideo(file);
            }
        },
        uploadVideo(file) {
            // 完成录制, 进行发送
            // this.$emit('sendVideo');
            var questData = this.$store.state.questData;
            var data = new FormData();
            data.append('authCode', questData.authCode);
            data.append('file', file);
            // console.log('上传视频', data);

            var self = this;

            $.ajax({
                url : URLS_GY.UPLOAD_FILE,
                type : 'POST',
                cache : false,
                data: data,
                dataType : 'json',
                processData: false,
                contentType: false,
                error : function() {
                    Utils.error('视频上传接口错误!');
                    // 录制结束
                    // self.recording = false;
                    self.btnLoading = false;
                    self.spinShow = false;
                },
                success : function(result) {
                    // console.log('发送完成', result);
                    if (result.code == '200') {
                        self.videoUrl = result.data.url;
                        // 提交视频地址
                        self.submitVideo();
                    } else {
                        // 录制结束
                        // self.recording = false;
                        Utils.error(result.msg);
                        self.btnLoading = false;
                        self.spinShow = false;
                    }
                }
            });
        },
        // 提交视频地址
        submitVideo() {
            var self = this;
            var questData = this.$store.state.questData;
            questData.recordVideoUrl = this.videoUrl;
            questData.deviceId = Utils.getUUID();
            // 提交视频地址
            GuangYuanDao.invokeSubmitVideo(questData, (resData) => {
                // 录制结束
                // self.recording = false;
                questData.recordVideoUrl = '';
                self.videoSrc = '';
                if (resData && resData.code == 200) {
                    self.$Message.success('录制完成, 1 秒后关闭');
                    // console.log('提交视频地址完成', resData);
                    // 1 秒后自动关闭
                    setTimeout(() => {
                        // 如果弹窗打开, 则关闭
                        if (self.videoRecordModal) self.videoRecordModal = false;
                        self.btnLoading = false;
                        self.spinShow = false;
                    }, 1000);
                } else {
                    self.btnLoading = false;
                    self.spinShow = false;
                    Utils.error(resData.msg);
                }
            });
        },
        getUserMediaError(error) {
            // Utils.warning('人脸识别', '没有摄像头或摄像头调用失败!');
            // console.log('访问用户媒体设备失败: ' + error.name + ',' + error.message);
            this.btnLoading = false;
            this.spinShow = false;
            if (ERROR_MSG.NOT_FOUND == error.name) {
                this.title = '未检测到摄像头';
                this.msg = '请安装好摄像头然后刷新页面';
                // hasWebcam=false;    //是否安装摄像头
                // console.log('是否安装摄像头');
            } else if (ERROR_MSG.NOT_ALLOWED == error.name) {
                this.title = '没有调用摄像头权限';
                // msg = '请允许浏览器使用摄像头,<a href="javascript:void(0)" onClick="seeErrorDetail(2)">查看详情</a>';
                this.msg = '请允许浏览器使用摄像头';
                // isWebcamAlreadyCaptured=false;//摄像头是否允许被调用
                // console.log('调用摄像头失败');
            } else if (ERROR_MSG.NOT_BROWSER == error.name) {
                this.title = '请更换浏览器';
                this.msg = '您的浏览器无法支持继续学习，推荐使用谷歌浏览器，如果使用的是360浏览器，请切换为极速模式，然后刷新页面';
                // isWebcamAlreadyCaptured=false;//摄像头是否允许被调用
                // console.log('请更换浏览器');
            } else if (ERROR_MSG.NOT_READABLE == error.name) {
                this.title = '摄像头被占用';
                this.msg = '摄像头可能被其它程序占用，请关闭使用摄像头的程序，再重试';
                // isWebcamAlreadyCaptured=false;//摄像头是否允许被调用
                // console.log('摄像头被占用');
            } else if (ERROR_MSG.NOT_SUPPORTED == error.name) {
                this.title = '不支持摄像头调用';
                this.msg = '请使用支持调用摄像头的浏览器';
            } else {
                // console.log('111===', msg);
                this.title = '启用摄像头出错';
                this.msg = '请确认摄像头可用，原因:'+error.name+','+error.message;
            }
            this.videoRecordModal = true;
            // Utils.error(this.title, this.msg);
        }
    },
    // 组件关闭
    destroyed() {
        try {
            this.stopRecord(function () {
                // console.log('录制视频组件关闭');
            });
        } catch {
            // console.log('catch-录制视频组件关闭');
        }
    },
};
</script>

<style lang="scss">
.face {

}
.mooc-charge-video-record-modal {
    text-align: center;
    .ivu-modal-footer {
        text-align: center;
        .a-upload {
            padding: 4px 10px;
            // height: 20px;
            line-height: 20px;
            position: relative;
            cursor: pointer;
            color: #fff;
            background: #2e8ded;
            border-color: #2e8ded;
            text-decoration: none;
            //border: 1px solid #ddd;
            border-radius: 4px;
            overflow: hidden;
            display: inline-block;
            *display: inline;
            *zoom: 1
        }
        .a-upload  input {
            position: absolute;
            font-size: 100px;
            right: 0;
            top: 0;
            opacity: 0;
            filter: alpha(opacity=0);
            cursor: pointer
        }
    }
    .ios-video {
    }
}

</style>
